"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonPlayTags = exports.SinglePlayTags = exports.RecapTags = exports.CompilationPlaylists = void 0;
/**
 * @swagger
 * definitions:
 *    CompilationPlaylists:
 *      type: string
 *      enum:
 *       - key-moments
 *       - pitchers-who-rake
 *       - real-fast
 *       - cut4
 *       - baseball-bloopers
 *       - tip-of-the-cap
 *       - fastcast
 *       - clinches-and-celebrations
 *       - home-runs
 */
var CompilationPlaylists;
(function (CompilationPlaylists) {
    CompilationPlaylists["KeyMoments"] = "key-moments";
    CompilationPlaylists["PitchersWhoRake"] = "pitchers-who-rake";
    CompilationPlaylists["RealFast"] = "real-fast";
    CompilationPlaylists["Cut4"] = "cut4";
    CompilationPlaylists["Bloopers"] = "baseball-bloopers";
    CompilationPlaylists["TipOfTheCap"] = "tip-of-the-cap";
    CompilationPlaylists["FastCast"] = "fastcast";
    CompilationPlaylists["ClinchesAndCelebrations"] = "clinches-and-celebrations";
    CompilationPlaylists["HomeRuns"] = "home-runs";
})(CompilationPlaylists || (exports.CompilationPlaylists = CompilationPlaylists = {}));
/**
 * @swagger
 * definitions:
 *    RecapTags:
 *      type: string
 *      enum:
 *       - highlight-reel-pitching
 *       - highlight-reel-starting-pitching
 *       - highlight-reel-offense
 *       - carry-the-freight
 *       - relief-performance
 *       - fast-cast
 *       - business-of-baseball
 *       - mlbn-rundown
 *       - player-of-the-week
 *       - clincher
 *       - quality-start
 *       - best-performer
 *       - rivalry
 */
var RecapTags;
(function (RecapTags) {
    RecapTags["PitchingHighlights"] = "highlight-reel-pitching";
    RecapTags["StartingPitchingHighlights"] = "highlight-reel-starting-pitching";
    RecapTags["OffenseHighlights"] = "highlight-reel-offense";
    RecapTags["CarryTheFreight"] = "carry-the-freight";
    RecapTags["ReliefPerformance"] = "relief-performance";
    RecapTags["FastCast"] = "fast-cast";
    RecapTags["BusinessOfBaseball"] = "business-of-baseball";
    RecapTags["MLBNetworkRundown"] = "mlbn-rundown";
    RecapTags["PlayerOfTheWeek"] = "player-of-the-week";
    RecapTags["Clincher"] = "clincher";
    RecapTags["QualityStart"] = "quality-start";
    RecapTags["BestPerformer"] = "best-performer";
    RecapTags["Rivalry"] = "rivalry";
})(RecapTags || (exports.RecapTags = RecapTags = {}));
/**
 * @swagger
 * definitions:
 *    SinglePlayTags:
 *      type: string
 *      enum:
 *       - defense
 *       - offense
 *       - home-run
 *       - replay
 *       - challenge
 *       - high-speed-play
 *       - clutch-moment
 *       - must-c
 *       - player-tracking
 *       - filthy-pitch
 *       - walk-off
 *       - extra-innings
 *       - grand-slam
 *       - milestone
 *       - pitchers-hitting-hr
 *       - double-play
 *       - triple-play
 *       - career-first
 *       - key-moments
 */
var SinglePlayTags;
(function (SinglePlayTags) {
    SinglePlayTags["Defense"] = "defense";
    SinglePlayTags["Offense"] = "offense";
    SinglePlayTags["HomeRuns"] = "home-run";
    SinglePlayTags["Replays"] = "replay";
    SinglePlayTags["Challenges"] = "challenge";
    SinglePlayTags["HighSpeed"] = "high-speed-play";
    SinglePlayTags["ClutchMoment"] = "clutch-moment";
    SinglePlayTags["MustC"] = "must-c";
    SinglePlayTags["Statcast"] = "player-tracking";
    SinglePlayTags["FilthyPitches"] = "filthy-pitch";
    SinglePlayTags["WalkOff"] = "walk-off";
    SinglePlayTags["ExtraInnings"] = "extra-innings";
    SinglePlayTags["GrandSlam"] = "grand-slam";
    SinglePlayTags["Milestone"] = "milestone";
    SinglePlayTags["PitcherHomeRuns"] = "pitchers-hitting-hr";
    SinglePlayTags["DoublePlay"] = "double-play";
    SinglePlayTags["TriplePlay"] = "triple-play";
    SinglePlayTags["CareerFirst"] = "career-first";
    SinglePlayTags["KeyMoments"] = "key-moments";
})(SinglePlayTags || (exports.SinglePlayTags = SinglePlayTags = {}));
/**
 * @swagger
 * definitions:
 *    NonPlayTags:
 *      type: string
 *      enum:
 *       - interview
 *       - injury
 *       - broadcasters
 *       - ceremonial-first-pitch
 */
var NonPlayTags;
(function (NonPlayTags) {
    NonPlayTags["Interviews"] = "interview";
    NonPlayTags["InjuryNews"] = "injury";
    NonPlayTags["Broadcasters"] = "broadcasters";
    NonPlayTags["CeremonialFirstPitch"] = "ceremonial-first-pitch";
})(NonPlayTags || (exports.NonPlayTags = NonPlayTags = {}));
